window.kontotypes = window.kontotypes || {};
kontotypes.gs = kontotypes.gs || {};
// Tip izvještaja za projekt.
kontotypes.gs.ProjektIzvj = {
	KARTICA: "Kartica",
	REKAPITULACIJA_STAVAKA: "Rekapitulacija stavki",
	STAVKE_XLS: "Stavke Excel"
};